import { render, staticRenderFns } from "./LibraryBanner.vue?vue&type=template&id=3b6bcd44&scoped=true"
import script from "./LibraryBanner.vue?vue&type=script&lang=js"
export * from "./LibraryBanner.vue?vue&type=script&lang=js"
import style0 from "./LibraryBanner.vue?vue&type=style&index=0&id=3b6bcd44&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b6bcd44",
  null
  
)

export default component.exports